<template>
  <b-form-checkbox
    v-model="localChecked"
    :aria-label="ariaLabel"
    :aria-labelledby="ariaLabelledby"
    :autofocus="autofocus"
    :checked="checked"
    :disabled="disabled"
    :form="form"
    :id="id"
    :indeterminate="indeterminate"
    :inline="inline"
    :name="name"
    :plain="plain"
    :required="required"
    :state="state"
    :switch="enableSwitch"
    :switch-color="switchColor"
    :switch-size="switchSize"
    :unchecked-value="uncheckedValue"
    :value="value"
    :class="[
      `custom-switch-${switchColor}`,
      {
        'custom-switch--small': enableSwitch && switchSize === 'small',
      }
    ]
    "
  >
    <slot />
  </b-form-checkbox>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue';

export default {
  name: 'MFormCheckbox',
  components: {
    BFormCheckbox,
  },
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    ariaLabel: {
      type: String,
      default: null,
    },
    ariaLabelledby: {
      type: String,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: [Array, Boolean],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    form: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: null,
    },
    plain: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    state: {
      type: Boolean,
      default: null,
    },
    enableSwitch: {
      type: Boolean,
      default: false,
    },
    switchColor: {
      type: String,
      default: 'primary',
    },
    switchSize: {
      type: String,
      default: null,
    },
    uncheckedValue: {
      type: [Array, Boolean],
      default: false,
    },
    value: {
      type: [Array, Boolean, String, Number],
      default: true,
    },
  },
  computed: {
    localChecked: {
      get() {
        return this.checked;
      },
      set(newValue) {
        this.$emit('input', newValue);
        this.$emit('change', newValue);
      },
    },
  },
  methods: {
    getButtonClass() {
      return this.enableSwitch ? `custom-switch-${this.switchColor}` : null;
    },
  },
};
</script>
